module.exports = __webpack_public_path__ + "static/media/dentist-chair.304e838c.jpg";